<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" dir="rtl">
  <div class="bb-page-shell">

    <div class="bb-page-header noPrint">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'Supply Invoice' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'الفاتورة' | transloco }}</h2>
        <p class="bb-page-subtitle">{{ 'رقم الفاتورة: #' | transloco }}{{invoiceId}}</p>
      </div>

      <div class="bb-header-actions">
        @if(!isMobile){
        <button onclick="window.print();" class="bb-btn bb-btn-primary">
          {{ 'اطبع' | transloco }}
        </button>
        }
      </div>
    </div>

    <div class="bb-card bb-p-20">

      <div class="bb-flex bb-items-center bb-justify-between bb-wrap bb-gap-16 bb-mb-16">
        <div class="bb-text-stack">
          <h1 class="bb-page-title bb-m-0">{{ 'فاتورة' | transloco }}</h1>
          <p class="bb-page-subtitle bb-m-0">{{ 'رقم الفاتورة: #' | transloco }}{{invoiceId}}</p>
          <p class="bb-page-subtitle bb-m-0">{{ 'التاريخ:' | transloco }} {{date}}</p>
        </div>

        <div class="bb-product-img-box">
          <img src="/assets/sup.png" [alt]="'Company Logo' | transloco" />
        </div>
      </div>

      <div class="bb-form-grid bb-mt-20">

        <div class="bb-card bb-p-16">
          <h3 class="bb-text-navy bb-font-bold bb-m-0 bb-mb-12">{{ 'المورد:' | transloco }}</h3>
          <p class="bb-m-0 bb-font-semibold">{{supplier_name}}</p>
        </div>

        <div class="bb-card bb-p-16">
          <h3 class="bb-text-navy bb-font-bold bb-m-0 bb-mb-12">{{ 'بيانات الفاتورة:' | transloco }}</h3>
          <p class="bb-m-0 bb-mb-8 bb-text-muted">{{ 'رقم الفاتورة: #' | transloco }}{{invoiceId}}</p>
          <p class="bb-m-0 bb-mb-8 bb-text-muted">{{ 'التاريخ:' | transloco }} {{date}}</p>

          <p class="bb-m-0 noPrint">
            <span class="bb-text-danger bb-font-bold">{{ 'ملاحظة:' | transloco }}</span>
            {{note}}
          </p>
        </div>

      </div>

      @if(isMobile){

      <div class="bb-grid bb-gap-12 bb-mt-20">
        <div class="bb-card bb-p-16" *ngFor="let product of products; let i = index">
          <div class="bb-text-stack">
            <p class="bb-m-0 bb-font-bold bb-text-navy">
              {{ 'المنتج:' | transloco }} {{products[i]}}
            </p>

            <p class="bb-m-0 bb-text-muted">
              {{ 'الكمية:' | transloco }} {{qty[i]}}
            </p>

            <p class="bb-m-0 bb-text-muted">
              {{ 'سعر الواحدة:' | transloco }} {{prices[i]}} {{ "egp" | transloco }}
            </p>

            <p class="bb-m-0 bb-price">
              {{ 'الاجمالي:' | transloco }} {{prices[i] * qty[i]}} {{ "egp" | transloco }}
            </p>
          </div>
        </div>

        <div class="bb-card bb-p-16 bb-bg-blue-soft">
          <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
            <span class="bb-font-bold bb-text-navy">{{ 'الاجمالي' | transloco }}</span>
            <strong class="bb-price">{{this.sumprices}} {{ "egp" | transloco }}</strong>
          </div>
        </div>
      </div>

      }@else{

      <div class="bb-table-card bb-mt-20">
        <div class="bb-table-scroll">
          <table class="bb-table">
            <thead>
              <tr>
                <th class="mat-header-cell-custom">{{ 'المنتج' | transloco }}</th>
                <th class="mat-header-cell-custom">{{ 'الكمية' | transloco }}</th>
                <th class="mat-header-cell-custom">{{ 'سعر الواحدة' | transloco }}</th>
                <th class="mat-header-cell-custom">{{ 'الاجمالي' | transloco }}</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let product of products; let i = index">
                <td class="mat-cell-custom bb-font-bold">{{products[i]}}</td>
                <td class="mat-cell-custom">{{qty[i]}}</td>
                <td class="mat-cell-custom">{{prices[i]}} {{ "egp" | transloco }}</td>
                <td class="mat-cell-custom bb-price">{{prices[i] * qty[i]}} {{ "egp" | transloco }}</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3">{{ 'الاجمالي' | transloco }}</td>
                <td class="mat-cell-custom bb-price">{{this.sumprices}} {{ "egp" | transloco }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      }

    </div>

  </div>
</section>